var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btnBox"},[_c('el-button',{staticClass:"backBtn",attrs:{"type":"text"},on:{"click":_vm.back}},[_c('i',{staticClass:"el-icon-arrow-left"}),_vm._v("\n    返回\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }